import { render, staticRenderFns } from "./widget-type.vue?vue&type=template&id=f831ac48&scoped=true"
import script from "./widget-type.vue?vue&type=script&lang=js"
export * from "./widget-type.vue?vue&type=script&lang=js"
import style0 from "./widget-type.vue?vue&type=style&index=0&id=f831ac48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f831ac48",
  null
  
)

export default component.exports